<template>
    <ValidationProvider v-slot="validationContext" :rules="rules" :name="name" slim>
        <b-form-group>
            <small v-show="icon" class="input-element-title">{{ inputVal === '' ? '' : placeholder }}</small>

            <b-input-group class="border-input" :style="{'--valid': Number($getValidationState(validationContext) || !validationContext.errors.length), '--borderOpacity': icon ? isActive ? 1 : 0.6 : 0}">
                <template #prepend v-if="icon">
                    <img class="input-element-prepend" :src="icon" :style="{height: iconHeight, width: iconWidth}">
                </template>

                <template #append>
                    <slot name="password" />
                </template>

                <b-form-input
                    v-model="inputVal"
                    ref="input"
                    :class="icon ? 'input-element py-0' : 'no-valid py-0'"
                    :type="type"
                    :style="icon ? '' : '-webkit-text-fill-color: black !important;'"
                    :placeholder="placeholder"
                    :debounce="debounce"
                    :autofocus="autofocus"
                    :autocomplete="autocomplete"
                    :state="!icon ? validationState(validationContext) : undefined"
                    @focus="isActive = true"
                    @blur="isActive = false"
                    @keyup.enter="onKeyEnterUp"
                />

                <div class="position-absolute" :style="warningPosition">
                    <img v-if="validationContext.errors[0] && icon" :id="`error${ind}`" :src="require('images/formIcons/failed-input.svg')" width="20px" height="20px">

                    <b-popover v-if="validationContext.errors[0]" triggers="hover" :target="icon ? `error${ind}` : $refs.input.$el" placement="top" variant="danger">
                        {{ validationContext.errors[0] }}
                    </b-popover>
                </div>
            </b-input-group>
        </b-form-group>
    </ValidationProvider>
</template>

<script>
    export default {
        name: 'VInput',

        props: {
            type: {
                type: String,
                required: true
            },
            value: {
                type: String,
                required: true
            },
            placeholder: {
                type: String,
                required: false
            },
            rules: {
                required: false
            },
            name: {
                type: String,
                required: false
            },
            icon: {
                type: String
            },
            iconHeight: {
                type: String,
                default: '38px'
            },
            iconWidth: {
                type: String,
                default: '20px'
            },
            debounce: {
                type: Number,
                default: 0
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            autocomplete: {
                type: String,
                default: 'on'
            },
            ind: {
                type: String,
                default: '0'
            }
        },

        data() {
            return {
                isActive: false
            };
        },

        computed: {
            inputVal: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            },

            warningPosition() {
                return !this.icon ? 'top: 7px; right: 5px;' : 'top: 10px; right: -25px;';
            }
        },

        methods: {
            onKeyEnterUp() {
                this.$emit('keyEnterUp');
            },

            validationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            }
        }
    };
</script>

<style scoped>
    .invalid-feedback {
        display: block;
    }

    .input-element-title {
        color: white;
        opacity: 0.6;
        padding-left: 35px;
    }

    .input-element-prepend {
        margin: 0 -35px 0 5px;
    }

    .border-input {
        border: 0 !important;
        border-bottom: 1px solid !important;
        border-radius: 0 !important;
        border-color: rgba(
            calc(var(--valid) * 255 + (1 - var(--valid)) * 220),
            calc(var(--valid) * 255 + (1 - var(--valid)) * 53),
            calc(var(--valid) * 255 + (1 - var(--valid)) * 69), var(--borderOpacity)) !important;
    }

    .input-element {
        padding-left: 35px !important;
        color: white !important;
        caret-color: white !important;
        background-color: transparent !important;
        border: 0 !important;
    }

    .input-element:active, :focus {
        box-shadow: none !important;
    }

    .input-element::placeholder {
        color: white !important;
        opacity: 0.6 !important;
    }

    .input-element:disabled {
        opacity: 0.65 !important;
    }

    input:-webkit-autofill::first-line {
        font-size: 1rem !important;
        font-family: var(--font-family-sans-serif) !important;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-text-fill-color: white !important;
        transition: background-color 5000s ease-in-out 0s;
        -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    }

    .no-valid.is-valid {
        border-color: rgb(189, 189, 189);
        background-image: none;
    }

    .no-valid.is-valid:focus {
        border-color: rgb(189, 189, 189);
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
    }
</style>
